import { VL_API_BASE_URL } from 'vince-core/constants/backendUrls';

/**
 * compact build information from environment (branch name, last commit hash, and build date).
 * @constant
 * @type {string}
 * The string is formatted as "BRANCH_NAME-LAST_COMMIT_HASH-BUILD_DATE".
 */
const buildInfo = `${import.meta.env.BRANCH_NAME}-${import.meta.env.LAST_COMMIT_HASH}-${import.meta.env.BUILD_DATE}`;

/**
 * Prints the build information to the console.
 * The output includes the project name
 * build information (branch name, last commit hash, and build date)
 */
function printBuildInfo () {
    if (import.meta.env.BRANCH_NAME && import.meta.env.LAST_COMMIT_HASH && import.meta.env.BUILD_DATE) {
        console.log(
            `%cVince Build%c✨${buildInfo}`,
            'background-color:#00c16a;color:#FFF;padding:0.25rem;border-top-left-radius:3px;border-bottom-left-radius:3px;',
            'background-color:black;color:#FFF;padding:0.25rem 0.35rem;border-top-right-radius:3px;border-bottom-right-radius:3px;'
        );
    }
}

function getTenantAliasFromAuthState (): string | undefined {
    try {
        const stateParam = new URLSearchParams(location.search).get('state');
        const customState = stateParam?.split('|').pop();
        const decoded = customState ? JSON.parse(atob(customState)) : undefined;
        return decoded?.o ? new URL(decoded.o).hostname.split('.')[0] : undefined;
    } catch {
        return undefined;
    }
}

function getTenantAlias () {
    // On the Microsoft auth redirect popup, the page's own host is the fixed
    // redirectUri host (not the tenant's), so prefer the tenant the parent
    // window embedded in the OAuth "state" param when present.
    const tenantFromAuthState = getTenantAliasFromAuthState();
    if (tenantFromAuthState) {
        return tenantFromAuthState;
    }

    let alias = location.host.split('.')[0];

    if (!alias || ['vince-live-vue3-app', 'vince-live-vue3-app-ui-testing', 'vince-beta', 'localhost:3000'].includes(alias)) { // check for localhost and s3 host temporarily
        alias = 'labs';
    }

    return alias; // tenantAlias will be the first part of the domain
}

function getTenantAuthDomain (pool: {tenantId: string, region: string}) {
    return `${pool.tenantId.toLowerCase()}.auth.${pool.region}.amazoncognito.com`;
}

function getOverriddenValue (baseUrl: string, suffix: string | undefined = undefined): string {
    const override = localStorage.getItem('override.' + suffix);
    if (override !== null) {
        return override;
    } else if (suffix) {
        return baseUrl + suffix;
    }
    return baseUrl;
}

function getServiceBaseUrl (suffix: string | undefined = undefined): string {
    return getOverriddenValue(VL_API_BASE_URL.replace('api.', 'services.'), suffix);
}

function getBaseUrl (suffix: string | undefined = undefined): string {
    return getOverriddenValue(VL_API_BASE_URL, suffix);
}

function getApplicationBaseUrl (): string {
    const config = useRuntimeConfig();
    return config.public.baseUrl;
}


export {
    buildInfo,
    printBuildInfo,
    getTenantAlias,
    getTenantAuthDomain,
    getBaseUrl,
    getServiceBaseUrl,
    getApplicationBaseUrl
};
